import { render, staticRenderFns } from "./UserParams.vue?vue&type=template&id=02369bfd"
import script from "./UserParams.vue?vue&type=script&lang=js"
export * from "./UserParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports